import React from 'react';
import './textInput.css';

const TextInput = ({
	label,
	type,
	placeholder,
	error,
	value,
	name,
	onChange,
	icon,
	check,
	customStyle,
	inputStyle,
	isTextArea,
	required = false
}) => {
	return (
		<div className='textInput' style={customStyle}>
			<label className='textInput__label'>{label}</label>
			<div className='inputBox'>
				{icon && (
					<svg className='inputBox__icon'>
						<use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
					</svg>
				)}
				{isTextArea ? (
					<textarea
						className='textInput__input'
						placeholder={placeholder}
						name={name}
						value={value}
						style={inputStyle}
						onChange={onChange}
						required={required}
						rows='2'
						cols='50'
					/>
				) : (
					<input
						className='textInput__input'
						type={type ? type : 'text'}
						placeholder={placeholder}
						name={name}
						value={value}
						style={inputStyle}
						onChange={onChange}
						required={required}
					/>
				)}
				{check ? (
					<svg
						id='icon-check'
						width='18'
						height='18'
						viewBox='0 0 18 18'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<circle cx='9' cy='9' r='9' fill='#4ED28B' />
						<path
							d='M5.66669 9L8.16669 11.5L12.3334 6.5'
							stroke='white'
							stroke-width='2'
							stroke-linecap='round'
							stroke-linejoin='round'
						/>
					</svg>
				) : (
					''
				)}
			</div>
			{error ? <p className='errorText'>{error}</p> : ''}
		</div>
	);
};

export default TextInput;
